import { useMutation, useQueryClient } from '@tanstack/react-query'

import { supabase } from '@/lib/supabase/cliente'
import { mensajeDeError } from '@/lib/supabase/errores'

/**
 * Corregir el radio de una zona sin salir de la programación.
 *
 * Es donde se ve el círculo mal puesto. Mandar al Gerente a una pantalla de
 * configuración a acordarse del problema después es garantizar que no se
 * corrija nunca.
 */
export function useAjustarZona() {
  const clienteConsultas = useQueryClient()

  return useMutation({
    mutationFn: async (datos: { zonaId: string; radioM: number | null; rural: boolean | null }) => {
      const { error } = await supabase.rpc('fn_ajustar_zona', {
        p_zona_id: datos.zonaId,
        p_radio_m: datos.radioM,
        p_rural: datos.rural,
      })

      if (error) throw new Error(mensajeDeError(error))
    },
    onSuccess: async () => {
      await Promise.all(
        [['sitio-de-la-orden'], ['maestro', 'zonas'], ['mis-geocercas']].map((clave) =>
          clienteConsultas.invalidateQueries({ queryKey: clave }),
        ),
      )
    },
  })
}
